/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily>): BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily(), model);
        BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily>): BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily.newInstance(<BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
